export {
	QuickActionButton,
	QuickActionsDropdown,
} from './components/QuickActions';
export { default as DynamicTabs } from './components/DynamicTabs.vue';

export { default as IntegrationActionsDropdown } from './components/IntegrationActionsDropdown.vue';
export { default as IntegrationActionsBubble } from './components/IntegrationActionsBubble.vue';
export {
	type Tab,
	type SyncStatusType,
	type SyncActionType,
	SyncStatus,
} from './components/types';
import { defineAsyncComponent } from 'vue';

export const integrationsMicroFrontends = {
	IntegrationsList: defineAsyncComponent(
		() => import('./components/IntegrationsList/IntegrationsList.vue')
	),
	IntegrationContainer: defineAsyncComponent(
		() =>
			import('./components/IntegrationContainer/IntegrationContainer.vue')
	),
	ExampleIntegration: defineAsyncComponent(
		() =>
			import('@/features/Integrations/components/ExampleIntegration/ExampleIntegration.vue')
	),
};
